$(function(){
  var now = new Date();
  var youbi = now.getDay(); //現在の日付
  
   if ( youbi == '1') {
        
	var tuki = now.getMonth() + 1 ; //現在の日付
     
    var ad = now.getDate() + 7;
    var adayOfWeek = now.getDay();	// 曜日(数値)
    
    var bd = now.getDate() + 6;
    var bdayOfWeek = now.getDay() - 1;	// 曜日(数値)
    
    var cd = now.getDate() + 9;
    var cdayOfWeek = now.getDay() + 2;	// 曜日(数値)
    
    var dd = now.getDate() + 16;
    var ddayOfWeek = now.getDay() + 2;	// 曜日(数値)
    
     
     if ( tuki == '1' || tuki == '3' || tuki == '5' || tuki == '7' || tuki == '8' || tuki == '10') {
       var ed = 31;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2; 
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }
       

    }
     
    if ( tuki == '4' || tuki == '6' || tuki == '9' || tuki == '11') {
       var ed = 30;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '2') {
       var x;
       x = now.getFullYear() % 4;
      
      if ( x == '0' ){
			var ed = 29;    
       }else {
    		var ed = 28;
  	   }
      
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '12') {
       var ed = 31;
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() -10;
         	var aye = now.getFullYear() + 1;
       }else {
    		var amm = now.getMonth() + 1;
         	var aye = now.getFullYear();
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() -10;
         	var bye = now.getFullYear() + 1;
       }else {
    		var bmm = now.getMonth() + 1;
         	var bye = now.getFullYear();
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() -10;
         	var cye = now.getFullYear() + 1;
       }else {
    		var cmm = now.getMonth() + 1;
         	var cye = now.getFullYear();
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() -10;
         	var dye = now.getFullYear() + 1;
       }else {
    		var dmm = now.getMonth() + 1;
         	var dye = now.getFullYear() + 1;
  	   }

    }
 
  }
 
  if ( youbi == '2') {
        
	var tuki = now.getMonth() + 1 ; //現在の日付
    
    var ad = now.getDate() + 6;
    var adayOfWeek = now.getDay() - 1;	// 曜日(数値)
    
    var bd = now.getDate() + 5;
    var bdayOfWeek = now.getDay() - 2;	// 曜日(数値)
    
    var cd = now.getDate() + 8;
    var cdayOfWeek = now.getDay() + 1;	// 曜日(数値)
    
    var dd = now.getDate() + 15;
    var ddayOfWeek = now.getDay() + 1;	// 曜日(数値)
    
         if ( tuki == '1' || tuki == '3' || tuki == '5' || tuki == '7' || tuki == '8' || tuki == '10') {
       var ed = 31;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2; 
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }
       

    }
     
    if ( tuki == '4' || tuki == '6' || tuki == '9' || tuki == '11') {
       var ed = 30;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '2') {
       var x;
       x = now.getFullYear() % 4;
      
      if ( x == '0' ){
			var ed = 29;    
       }else {
    		var ed = 28;
  	   }
      
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '12') {
       var ed = 31;
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() -10;
         	var aye = now.getFullYear() + 1;
       }else {
    		var amm = now.getMonth() + 1;
         	var aye = now.getFullYear();
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() -10;
         	var bye = now.getFullYear() + 1;
       }else {
    		var bmm = now.getMonth() + 1;
         	var bye = now.getFullYear();
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() -10;
         	var cye = now.getFullYear() + 1;
       }else {
    		var cmm = now.getMonth() + 1;
         	var cye = now.getFullYear();
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() -10;
         	var dye = now.getFullYear() + 1;
       }else {
    		var dmm = now.getMonth() + 1;
         	var dye = now.getFullYear() + 1;
  	   }

    }
 
  }
  
   if ( youbi == '3') {
        
	var tuki = now.getMonth() + 1 ; //現在の日付
    
    var ad = now.getDate() + 5;
    var adayOfWeek = now.getDay() - 2;	// 曜日(数値)
    
    var bd = now.getDate() + 4;
    var bdayOfWeek = now.getDay() - 3;	// 曜日(数値)
    
    var cd = now.getDate() + 7;
    var cdayOfWeek = now.getDay();	// 曜日(数値)
    
    var dd = now.getDate() + 14;
    var ddayOfWeek = now.getDay();	// 曜日(数値)
     
     if ( tuki == '1' || tuki == '3' || tuki == '5' || tuki == '7' || tuki == '8' || tuki == '10') {
       var ed = 31;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2; 
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }
       

    }
     
    if ( tuki == '4' || tuki == '6' || tuki == '9' || tuki == '11') {
       var ed = 30;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;    
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '2') {
       var x;
       x = now.getFullYear() % 4;
      
      if ( x == '0' ){
			var ed = 29;    
       }else {
    		var ed = 28;
  	   }
      
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '12') {
       var ed = 31;
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() -10;
         	var aye = now.getFullYear() + 1;
       }else {
    		var amm = now.getMonth() + 1;
         	var aye = now.getFullYear();
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() -10;
         	var bye = now.getFullYear() + 1;
       }else {
    		var bmm = now.getMonth() + 1;
         	var bye = now.getFullYear();
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() -10;
         	var cye = now.getFullYear() + 1;
       }else {
    		var cmm = now.getMonth() + 1;
         	var cye = now.getFullYear();
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() -10;
         	var dye = now.getFullYear() + 1;
       }else {
    		var dmm = now.getMonth() + 1;
         	var dye = now.getFullYear() + 1;
  	   }

    }
 
  }
  
  if ( youbi == '4') {
        
	var tuki = now.getMonth() + 1 ; //現在の日付
    
    var ad = now.getDate() + 4;
    var adayOfWeek = now.getDay() - 3;	// 曜日(数値)
    
    var bd = now.getDate() + 3;
    var bdayOfWeek = now.getDay() - 4;	// 曜日(数値)
    
    var cd = now.getDate() + 6;
    var cdayOfWeek = now.getDay() - 1;	// 曜日(数値)
    
    var dd = now.getDate() + 13;
    var ddayOfWeek = now.getDay() - 1;	// 曜日(数値)
    
         if ( tuki == '1' || tuki == '3' || tuki == '5' || tuki == '7' || tuki == '8' || tuki == '10') {
       var ed = 31;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2; 
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }
       

    }
     
    if ( tuki == '4' || tuki == '6' || tuki == '9' || tuki == '11') {
       var ed = 30;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '2') {
       var x;
       x = now.getFullYear() % 4;
      
      if ( x == '0' ){
			var ed = 29;    
       }else {
    		var ed = 28;
  	   }
      
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '12') {
       var ed = 31;
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() -10;
         	var aye = now.getFullYear() + 1;
       }else {
    		var amm = now.getMonth() + 1;
         	var aye = now.getFullYear();
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() -10;
         	var bye = now.getFullYear() + 1;
       }else {
    		var bmm = now.getMonth() + 1;
         	var bye = now.getFullYear();
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() -10;
         	var cye = now.getFullYear() + 1;
       }else {
    		var cmm = now.getMonth() + 1;
         	var cye = now.getFullYear();
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() -10;
         	var dye = now.getFullYear() + 1;
       }else {
    		var dmm = now.getMonth() + 1;
         	var dye = now.getFullYear() + 1;
  	   }

    }
 
  }
  
  if ( youbi == '5') {
        
	var tuki = now.getMonth() + 1 ; //現在の日付
    
    var ad = now.getDate() + 3;
    var adayOfWeek = now.getDay() - 4;	// 曜日(数値)
    
    var bd = now.getDate() + 2;
    var bdayOfWeek = now.getDay() - 5;	// 曜日(数値)
    
    var cd = now.getDate() + 5;
    var cdayOfWeek = now.getDay() - 2;	// 曜日(数値)
    
    var dd = now.getDate() + 12;
    var ddayOfWeek = now.getDay() - 2;	// 曜日(数値)
    
         if ( tuki == '1' || tuki == '3' || tuki == '5' || tuki == '7' || tuki == '8' || tuki == '10') {
       var ed = 31;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2; 
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }
       

    }
     
    if ( tuki == '4' || tuki == '6' || tuki == '9' || tuki == '11') {
       var ed = 30;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '2') {
       var x;
       x = now.getFullYear() % 4;
      
      if ( x == '0' ){
			var ed = 29;    
       }else {
    		var ed = 28;
  	   }
      
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '12') {
       var ed = 31;
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() -10;
         	var aye = now.getFullYear() + 1;
       }else {
    		var amm = now.getMonth() + 1;
         	var aye = now.getFullYear();
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() -10;
         	var bye = now.getFullYear() + 1;
       }else {
    		var bmm = now.getMonth() + 1;
         	var bye = now.getFullYear();
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() -10;
         	var cye = now.getFullYear() + 1;
       }else {
    		var cmm = now.getMonth() + 1;
         	var cye = now.getFullYear();
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() -10;
         	var dye = now.getFullYear() + 1;
       }else {
    		var dmm = now.getMonth() + 1;
         	var dye = now.getFullYear() + 1;
  	   }

    }
 
  }
  
  if ( youbi == '6') {
        
	var tuki = now.getMonth() + 1 ; //現在の日付
    
    var ad = now.getDate() + 2;
    var adayOfWeek = now.getDay() - 5;	// 曜日(数値)
    
    var bd = now.getDate() + 1;
    var bdayOfWeek = now.getDay() - 6;	// 曜日(数値)
    
    var cd = now.getDate() + 4;
    var cdayOfWeek = now.getDay() - 3;	// 曜日(数値)
    
    var dd = now.getDate() + 11;
    var ddayOfWeek = now.getDay() - 3;	// 曜日(数値)
    
         if ( tuki == '1' || tuki == '3' || tuki == '5' || tuki == '7' || tuki == '8' || tuki == '10') {
       var ed = 31;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2; 
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }
       

    }
     
    if ( tuki == '4' || tuki == '6' || tuki == '9' || tuki == '11') {
       var ed = 30;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '2') {
       var x;
       x = now.getFullYear() % 4;
      
      if ( x == '0' ){
			var ed = 29;    
       }else {
    		var ed = 28;
  	   }
      
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '12') {
       var ed = 31;
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() -10;
         	var aye = now.getFullYear() + 1;
       }else {
    		var amm = now.getMonth() + 1;
         	var aye = now.getFullYear();
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() -10;
         	var bye = now.getFullYear() + 1;
       }else {
    		var bmm = now.getMonth() + 1;
         	var bye = now.getFullYear();
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() -10;
         	var cye = now.getFullYear() + 1;
       }else {
    		var cmm = now.getMonth() + 1;
         	var cye = now.getFullYear();
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() -10;
         	var dye = now.getFullYear() + 1;
       }else {
    		var dmm = now.getMonth() + 1;
         	var dye = now.getFullYear() + 1;
  	   }

    }
 
  }
  
   if ( youbi == '0') {
     
    var mon = now.getHours();
     
     if ( '0' <= mon && mon <= '12' ) {
        
	var tuki = now.getMonth() + 1 ; //現在の日付
    
    var ad = now.getDate() + 1;
    var adayOfWeek = now.getDay() + 1;	// 曜日(数値)
    
    var bd = now.getDate();
    var bdayOfWeek = now.getDay();	// 曜日(数値)
    
    var cd = now.getDate() + 3;
    var cdayOfWeek = now.getDay() + 3;	// 曜日(数値)
    
    var dd = now.getDate() + 10;
    var ddayOfWeek = now.getDay() + 3;	// 曜日(数値)
    
         if ( tuki == '1' || tuki == '3' || tuki == '5' || tuki == '7' || tuki == '8' || tuki == '10') {
       var ed = 31;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2; 
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }
       

    }
     
    if ( tuki == '4' || tuki == '6' || tuki == '9' || tuki == '11') {
       var ed = 30;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '2') {
       var x;
       x = now.getFullYear() % 4;
      
      if ( x == '0' ){
			var ed = 29;    
       }else {
    		var ed = 28;
  	   }
      
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '12') {
       var ed = 31;
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() -10;
         	var aye = now.getFullYear() + 1;
       }else {
    		var amm = now.getMonth() + 1;
         	var aye = now.getFullYear();
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() -10;
         	var bye = now.getFullYear() + 1;
       }else {
    		var bmm = now.getMonth() + 1;
         	var bye = now.getFullYear();
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() -10;
         	var cye = now.getFullYear() + 1;
       }else {
    		var cmm = now.getMonth() + 1;
         	var cye = now.getFullYear();
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() -10;
         	var dye = now.getFullYear() + 1;
       }else {
    		var dmm = now.getMonth() + 1;
         	var dye = now.getFullYear() + 1;
  	   }

    }
       
    } else if ( mon == '13' ) {
      
      
    var mday = now.getMinutes();
      
      if ( mday == '0' )  {
        
	var tuki = now.getMonth() + 1 ; //現在の日付
    
    var ad = now.getDate() + 1;
    var adayOfWeek = now.getDay() + 1;	// 曜日(数値)
    
    var bd = now.getDate();
    var bdayOfWeek = now.getDay();	// 曜日(数値)
    
    var cd = now.getDate() + 3;
    var cdayOfWeek = now.getDay() + 3;	// 曜日(数値)
    
    var dd = now.getDate() + 10;
    var ddayOfWeek = now.getDay() + 3;	// 曜日(数値)
    
         if ( tuki == '1' || tuki == '3' || tuki == '5' || tuki == '7' || tuki == '8' || tuki == '10') {
       var ed = 31;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2; 
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }
       

    }
     
    if ( tuki == '4' || tuki == '6' || tuki == '9' || tuki == '11') {
       var ed = 30;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '2') {
       var x;
       x = now.getFullYear() % 4;
      
      if ( x == '0' ){
			var ed = 29;    
       }else {
    		var ed = 28;
  	   }
      
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '12') {
       var ed = 31;
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() -10;
         	var aye = now.getFullYear() + 1;
       }else {
    		var amm = now.getMonth() + 1;
         	var aye = now.getFullYear();
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() -10;
         	var bye = now.getFullYear() + 1;
       }else {
    		var bmm = now.getMonth() + 1;
         	var bye = now.getFullYear();
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() -10;
         	var cye = now.getFullYear() + 1;
       }else {
    		var cmm = now.getMonth() + 1;
         	var cye = now.getFullYear();
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() -10;
         	var dye = now.getFullYear() + 1;
       }else {
    		var dmm = now.getMonth() + 1;
         	var dye = now.getFullYear() + 1;
  	   }

    }
      
    } else {
  	  
        
    var tuki = now.getMonth() + 1 ; //現在の日付
    
    var ad = now.getDate() + 8;
    var adayOfWeek = now.getDay() + 1;	// 曜日(数値)
    
    var bd = now.getDate() + 7;
    var bdayOfWeek = now.getDay();	// 曜日(数値)
    
    var cd = now.getDate() + 10;
    var cdayOfWeek = now.getDay() + 3;	// 曜日(数値)
    
    var dd = now.getDate() + 17;
    var ddayOfWeek = now.getDay() + 3;	// 曜日(数値)
    
         if ( tuki == '1' || tuki == '3' || tuki == '5' || tuki == '7' || tuki == '8' || tuki == '10') {
       var ed = 31;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2; 
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }
       

    }
     
    if ( tuki == '4' || tuki == '6' || tuki == '9' || tuki == '11') {
       var ed = 30;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '2') {
       var x;
       x = now.getFullYear() % 4;
      
      if ( x == '0' ){
			var ed = 29;    
       }else {
    		var ed = 28;
  	   }
      
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '12') {
       var ed = 31;
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() -10;
         	var aye = now.getFullYear() + 1;
       }else {
    		var amm = now.getMonth() + 1;
         	var aye = now.getFullYear();
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() -10;
         	var bye = now.getFullYear() + 1;
       }else {
    		var bmm = now.getMonth() + 1;
         	var bye = now.getFullYear();
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() -10;
         	var cye = now.getFullYear() + 1;
       }else {
    		var cmm = now.getMonth() + 1;
         	var cye = now.getFullYear();
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() -10;
         	var dye = now.getFullYear() + 1;
       }else {
    		var dmm = now.getMonth() + 1;
         	var dye = now.getFullYear() + 1;
  	   }

    }
      
        
   }
       
      
    } else {
        
    var tuki = now.getMonth() + 1 ; //現在の日付
    
    var ad = now.getDate() + 8;
    var adayOfWeek = now.getDay() + 1;	// 曜日(数値)
    
    var bd = now.getDate() + 7;
    var bdayOfWeek = now.getDay();	// 曜日(数値)
    
    var cd = now.getDate() + 10;
    var cdayOfWeek = now.getDay() + 3;	// 曜日(数値)
    
    var dd = now.getDate() + 17;
    var ddayOfWeek = now.getDay() + 3;	// 曜日(数値)
    
         if ( tuki == '1' || tuki == '3' || tuki == '5' || tuki == '7' || tuki == '8' || tuki == '10') {
       var ed = 31;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2; 
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }
       

    }
     
    if ( tuki == '4' || tuki == '6' || tuki == '9' || tuki == '11') {
       var ed = 30;
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '2') {
       var x;
       x = now.getFullYear() % 4;
      
      if ( x == '0' ){
			var ed = 29;    
       }else {
    		var ed = 28;
  	   }
      
       var aye = now.getFullYear();
       var bye = now.getFullYear();
       var cye = now.getFullYear();
       var dye = now.getFullYear();
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() + 2;     
       }else {
    		var amm = now.getMonth() + 1;
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() + 2;     
       }else {
    		var bmm = now.getMonth() + 1;
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() + 2;     
       }else {
    		var cmm = now.getMonth() + 1;
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() + 2;     
       }else {
    		var dmm = now.getMonth() + 1;
  	   }

    }
     
    if ( tuki == '12') {
       var ed = 31;
       
       if ( ad > ed ){
			var ad = ad - ed;
         	var amm = now.getMonth() -10;
         	var aye = now.getFullYear() + 1;
       }else {
    		var amm = now.getMonth() + 1;
         	var aye = now.getFullYear();
  	   }
       
       if ( bd > ed ){
			var bd = bd - ed;
         	var bmm = now.getMonth() -10;
         	var bye = now.getFullYear() + 1;
       }else {
    		var bmm = now.getMonth() + 1;
         	var bye = now.getFullYear();
  	   }
       
       if ( cd > ed ){
			var cd = cd - ed;
         	var cmm = now.getMonth() -10;
         	var cye = now.getFullYear() + 1;
       }else {
    		var cmm = now.getMonth() + 1;
         	var cye = now.getFullYear();
  	   }
       
       if ( dd > ed ){
			var dd = dd - ed;
         	var dmm = now.getMonth() -10;
         	var dye = now.getFullYear() + 1;
       }else {
    		var dmm = now.getMonth() + 1;
         	var dye = now.getFullYear() + 1;
  	   }

    }
       
    }
 
  }
  
  
    y=aye;
    m=amm;
    add=ad;
	aw = [ "日", "月", "火", "水", "木", "金", "土" ][adayOfWeek] ;	// 曜日(日本語表記)
    
　	$('#demo1').text(y + '年' + m + '月' + add + '日' + '（' + aw + '）');
    
    y=bye;
    m=bmm;
    bdd=bd;
	bw = [ "日", "月", "火", "水", "木", "金", "土" ][bdayOfWeek] ;	// 曜日(日本語表記)
    
　	$('#demo2').text(y + '年' + m + '月' + bdd + '日' + '（' + bw + '）');
      $('#demo4').text(y + '年' + m + '月' + bdd + '日' + '（' + bw + '）');
    
    y=cye;
    m=cmm;
    cdd=cd;
	cw = [ "日", "月", "火", "水", "木", "金", "土" ][cdayOfWeek] ;	// 曜日(日本語表記)
    
　	$('#demo3').text(y + '年' + m + '月' + cdd + '日' + '（' + cw + '）');
  	  $('#demo6').text(y + '年' + m + '月' + cdd + '日' + '（' + cw + '）');
    
    y=dye;
    m=dmm;
    ddd=dd;
	dw = [ "日", "月", "火", "水", "木", "金", "土" ][ddayOfWeek] ;	// 曜日(日本語表記)
    
　	$('#demo5').text(y + '年' + m + '月' + ddd + '日' + '（' + dw + '）');


});
